import React from 'react'
import NxRange from '../NxRange'

export default class Index extends React.Component {
  state = {
    value: this.props.value.length > 0 ? this.props.value : this.props.range,
  }

  handleRangeChange = (value) => this.setState({ value })

  render() {
    const { range, step, currency, name } = this.props
    const { value } = this.state
    const [min, max] = range
    const [minPrice, maxPrice] = value

    return (
      <div className='price-range mb-3'>
        <small className='text-muted'>{`${minPrice} - ${maxPrice} ${currency}`}</small>
        <NxRange
          step={step || 1}
          min={min}
          max={max}
          tooltip={false}
          onChange={this.handleRangeChange}
          onAfterChange={(val) => this.props.handleChange({ [name]: val })}
          value={value}
        />
      </div>
    )
  }
}
